import React from 'react';


import imageOnError from '../helpers/imgOnError.js';

import {
	_isGoogleIcon,
	_getGoogleIcon
	} from '../helpers/helpers'

interface TechnologySmallIconProps {
	technologyIcon: string;
	technology: string;
}

export default function TechnologySmallIcon({technologyIcon, technology}: TechnologySmallIconProps) {
	
	if (!technologyIcon) {
		return (<TechnologySmallNoIcon technologyIcon={technologyIcon} technology={technology}/>);
	}

	return (
		<>
			{
				_isGoogleIcon(technologyIcon) &&
					<TechnologySmallGoogleIcon technologyIcon={technologyIcon} technology={technology}/>
			}
			{
				!_isGoogleIcon(technologyIcon) &&
					<TechnologySmallInternalIcon technologyIcon={technologyIcon} technology={technology}/>
			}
		</>
	)
}

function TechnologySmallNoIcon({technologyIcon, technology}: TechnologySmallIconProps) {
	return (<>
			<img width="25" height="25" style={{width: '25px'}} title={technology} src={`/s/img/logo25.png`}
			/>
	</>)
}

function TechnologySmallGoogleIcon({technologyIcon, technology}: TechnologySmallIconProps) {


	return (
	    <img 
width="25" height="25" 
style={{width: '25px'}} 
src={`https://www.google.com/s2/favicons?domain=${_getGoogleIcon(technologyIcon)}`} 
onError={imageOnError}
		/>    
	)
}

function TechnologySmallInternalIcon({technologyIcon, technology}: TechnologySmallIconProps) {
	return (
        <img 
width="25" height="25" 
style={{width: '25px'}} 
title={technology}
src={`/s/ti/${technologyIcon}`} 
		/>
	)
}
